import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Grid } from '@mui/material';
import { HSpacer } from '@nx-smartmonkey/ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as routing from '../../constants/Routing';
import Button from '../../react-components/Button';
import Text from '../../react-components/Text';

type UnderLicenseClaimProps = {
  headerText: string;
};

export const UnderLicenseClaim = ({ headerText, children }: React.PropsWithChildren<UnderLicenseClaimProps>) => {
  const navigate = useNavigate();
  return (
    <Grid container direction="column" style={{ height: `100%` }}>
      <Grid
        container
        wrap="nowrap"
        alignItems="center"
        style={{ padding: `0 12px`, backgroundColor: `#5073B5`, height: `60px` }}
      >
        <Grid item container style={{ width: `100%` }} justifyContent="center" alignItems="center">
          <Grid item style={{ borderRadius: `50%`, backgroundColor: `white`, width: `24px`, height: `24px` }}>
            <ArrowUpwardIcon style={{ color: `#8ca3cf` }} />
          </Grid>
          <HSpacer small />
          <Text variant="body-medium" style={{ color: `white` }}>
            {headerText}
          </Text>
        </Grid>
        <Grid item>
          <Button
            style={{
              backgroundColor: `white`,
              width: `120px`,
            }}
            onClick={() => {
              navigate(`${routing.SETTINGS.BILLING.SUBSCRIPTION}`);
            }}
          >
            <Text style={{ cursor: `pointer`, color: `#5073B5` }} intlId="user_profile_summary.upgradeaccount" />
          </Button>
        </Grid>
      </Grid>

      <Grid container style={{ height: `calc(100% - 60px)` }}>
        {children}
      </Grid>
    </Grid>
  );
};
